import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getMappingRequiredFields, saveFileMapping } from '../store/actions/mapping';
import { canSave, getImportRequest } from '../store/selectors';
import MappingSettings from './mapping-setting';
import MappingMappedData from './mapping-mapped-data';
import MappingIgnoredData from './mapping-ignored-data';
import NewImportCancelModal from '../new_import_cancel_modal';

export function MappingDetail({
  importRequest,
  canSave,
  onSubmit
}) {
  const history = useHistory();

  const handleSubmit = () => {
    onSubmit()
      .then((response) => {
        if (response) {
          history.push(`/${importRequest.id}/mapping`);
        }
      });
  };

  return (
    <React.Fragment>
      <MappingMappedData />
      <MappingIgnoredData />
      <MappingSettings />
      <div className="container mb-4 p-0">
        <NewImportCancelModal />
        <button className="btn btn-save ml-2" disabled={!canSave} onClick={handleSubmit}>
          Save &amp; Continue
        </button>
      </div>
    </React.Fragment>
  );
}

MappingDetail.propTypes = {
  canSave: PropTypes.bool.isRequired,
  getRequiredFields: PropTypes.func.isRequired,
  importRequest: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  canSave: canSave(state),
  importRequest: getImportRequest(state)
});

const mapDispatchToProps = {
  getRequiredFields: getMappingRequiredFields,
  onSubmit: saveFileMapping
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingDetail);
